import { useContext, useCallback, useMemo } from "react";

import { TenantContext } from "../../../templates/context/TenantContext";

import { Text, Icon } from "@aidron/aidron-ds";

import PropTypes from 'prop-types';

export function PercentBodyCell({ ctx, uiState }) {

  const { prediction } = ctx || {};
  const {
    showFlag,
    enablePercentualValue,
    predictionForFlagColor
  } = uiState ||{};

  const { unit } = useContext(TenantContext);

  const defineFlagColor = useCallback(() => {
    const delta = predictionForFlagColor || prediction;
    if (delta < 5 && delta > -5) return "color-green";
    if (delta >= 25 || delta <= -25) return "color-red";
    else return "color-dark-yellow";
  }, [predictionForFlagColor, prediction]);

  const parsedPrediction = typeof prediction === "string" ? Number(prediction) : prediction;
  const positiveOrNegativeValue = parsedPrediction < 0 ? "- " : "";

  const numberFormatter = useMemo(() => {
    const locale = "pt-BR";
    const options = {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    };

    if (enablePercentualValue) {
      options.style = "percent";
    } else if (unit === "currency") {
      options.style = "currency";
      options.currency = "BRL";
    } else {
      options.style = "decimal";
    }

    return new Intl.NumberFormat(locale, options);
  }, [unit, enablePercentualValue]);

  const formatValue = useCallback(() => {
    const absValue = Math.abs(parsedPrediction);

    if (enablePercentualValue) return `${positiveOrNegativeValue}${numberFormatter.format(absValue / 100)}`;
    if (unit === "currency") return `${positiveOrNegativeValue}${numberFormatter.format(absValue)}`;

    return numberFormatter.format(parsedPrediction);
  }, [enablePercentualValue, unit, parsedPrediction, numberFormatter, positiveOrNegativeValue]);

  return (
    <div className="row">
      {parsedPrediction !== null && !isNaN(parsedPrediction) ? (
        <>
          {showFlag && (
            <div className="col-4 d-flex justify-content-end pe-0">
              <Icon icon="flag" className={`me-1 ${defineFlagColor()}`} />
            </div>
          )}

          <div className={showFlag ? "d-flex col-8 justify-content-start ps-0" : "text-center"}>
            <Text>{formatValue()}</Text>
          </div>
        </>
      ) : (
        <div className="col d-flex justify-content-center">
          <Text>N/A</Text>
        </div>
      )}
    </div>
  );
};

PercentBodyCell.propTypes = {
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
};